import { parseGenericCSV } from './generic';
import type { NormalizedImport } from '../normalizedImport';

// Asana CSV exports use these columns: Name, Notes, Assignee, Due Date, Start Date,
// Section/Column, Tags, Parent task, Subtask, Dependencies.
// Generic parser handles these; we just label the source.
export function parseAsanaCSV(csvText: string): NormalizedImport {
  return parseGenericCSV(csvText, 'asana');
}
